// extracted by css-extract-rspack-plugin
export default {"sharedAvatar":"sharedAvatar-RxHzTz"};